import { lazyWithPreload } from '../../navigation';

export const SpaceScreen = lazyWithPreload(() =>
    import('./Screen/SpaceScreen').then((m) => ({ default: m.SpaceScreen }))
);
